declare var $;

interface IPaymentData {
    term_type: number;
    balance: number;
}

/**
 * Class to fetch the approval section's HTML via AJAX and handle the user interactions with the results.
 */
export class ApprovalSection {
    /**
     * @var {string} sales_id of the order.
     */
    sales_id: string;

    /**
     * Fetch the HTML for the section on load, then when complete bind the controls.
     *
     * @param {string} sales_id of the order.
     */
    constructor(sales_id:string) {
        this.sales_id = sales_id;
    }

    /**
     * Fetches the DOM content for the approval section.
     * @param payment_data term type and balance
     * @returns {void}
     */
    async_init(payment_data: IPaymentData) : void {
        const approval_section = document.getElementById('js-order-details-approval-section');
        if (!approval_section) {
            // Approval is not needed
            return;
        }

        $.ceAjax('request', 'index.php?dispatch=tv_customer_orders.approval_status', {
            method: 'POST',
            cache: false,
            hidden: true,
            result_ids: 'js-order-details-approval-section',
            callback: this.async_init_callback.bind(this),
            data: {
                sales_id: this.sales_id,
                term_type: payment_data.term_type,
                balance: payment_data.balance,
                customer_approved:  approval_section.dataset.customerApproved
            }
        });
    }

    /**
     * When the DOM content is returned, bind the approve button.
     *
     * @returns {void}
     */
    async_init_callback() : void {
        const approve_button = document.getElementById('js-order-approve-button');
        approve_button?.addEventListener('click', this.approve_order.bind(this));
    }

    /**
     * Approve the order
     */
    approve_order() : void {
        $.ceAjax('request', 'index.php?dispatch=tv_customer_orders.approve_order', {
            method: 'POST',
            cache: false,
            hidden: false,
            data: {
                sales_id: this.sales_id
            },
            callback: () => {
                location.reload();
            }
        });
    }
}
